import styled from 'styled-components';

interface BadgeProps {
  variant?: 'nuovo' | 'positivo' | 'negativo' | 'in_corso' | 'qualified' | 'contacted' | 'interested' | 'not_interested' | 'default';
  size?: 'small' | 'medium' | 'large';
}

const getBadgeStyles = (variant: string = 'default') => {
  switch (variant) {
    case 'nuovo':
      return {
        background: '#f3f4f6',
        color: '#374151'
      };
    case 'positivo':
    case 'qualified':
      return {
        background: '#dcfce7',
        color: '#166534'
      };
    case 'negativo':
    case 'not_interested':
      return {
        background: '#fee2e2',
        color: '#dc2626'
      };
    case 'in_corso':
    case 'interested':
      return {
        background: '#fef3c7',
        color: '#92400e'
      };
    case 'contacted':
      return {
        background: '#dbeafe',
        color: '#1e40af'
      };
    default:
      return {
        background: '#f1f5f9',
        color: '#475569'
      };
  }
};

const getSizeStyles = (size: string = 'medium') => {
  switch (size) {
    case 'small':
      return `
        padding: 2px 6px;
        font-size: 0.625rem;
      `;
    case 'large':
      return `
        padding: 6px 12px;
        font-size: 0.875rem;
      `;
    default:
      return `
        padding: 4px 8px;
        font-size: 0.75rem;
      `;
  }
};

export const Badge = styled.span<BadgeProps>`
  ${props => getSizeStyles(props.size)}
  
  border-radius: 12px;
  font-weight: 500;
  text-transform: capitalize;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  background: ${props => getBadgeStyles(props.variant).background};
  color: ${props => getBadgeStyles(props.variant).color};
`;

// Status badge specifically for contact status
export const StatusBadge = styled(Badge)`
  // Inherits all Badge styles with status-specific variants
`;

// Vacancy badge for job postings
export const VacancyBadge = styled(Badge)`
  background: #e0f2fe;
  color: #0277bd;
  font-size: 0.75rem;
  padding: 2px 8px;
  margin-left: 8px;
`;